import { useState } from "react";
import UserMerchViewModal from "./UserMerchViewModal";
import MerchDropUserResponseModalContainer from "./MerchDropUserResponseModalContainer";

function MerchDropPublicViewModalContainer({
  mementoId,
  onClose,
  isMementoOwnedByUser,
  merchDropData,
  refetch,
}: {
  mementoId: string;
  onClose: () => void;
  isMementoOwnedByUser?: boolean;
  merchDropData: MerchDropUserData;
  refetch: () => void;
}) {
  const [isMerchDropClaimModalOpen, setIsMerchDropClaimModalOpen] = useState(false);

  const handleMerchDropClaimModalClose = () => {
    setIsMerchDropClaimModalOpen(false);
  };

  const handleClaimButtonClick = () => {
    setIsMerchDropClaimModalOpen(true);
  };

  return (
    <>
      {isMerchDropClaimModalOpen && (
        <MerchDropUserResponseModalContainer
          merchDropDetails={merchDropData}
          onClose={handleMerchDropClaimModalClose}
          merchDropId={mementoId}
          refetchMerchDropData={refetch}
        />
      )}
      <UserMerchViewModal
        handleClaimButtonClick={handleClaimButtonClick}
        merchDropDetails={merchDropData}
        onClose={onClose}
        disableClaimButtonClick={!isMementoOwnedByUser}
      />
    </>
  );
}

export default MerchDropPublicViewModalContainer;
